<!-- AI: Status: "in progress", Type: Component, SubType: WizardStep, Reason: Step 2 logic block selection and create -->
<div class="flex flex-column gap-4">

    <h3 class="mt-0 mb-1 text-lg font-semibold">
        <i class="fa-regular fa-cubes mr-2"></i>Logik-Blöcke auswählen und sortieren
    </h3>

    <p class="text-500 mt-0 mb-2">
        Wählen Sie die Logik-Blöcke aus, die für die Berechnung verwendet werden sollen, und bringen Sie sie in die richtige Reihenfolge.
    </p>

    <!-- Add Logic Dropdown -->
    <div class="flex gap-2 align-items-end">
        <div class="flex-grow-1">
            <p-select [options]="availableLogics"
                      [(ngModel)]="selectedLogicToAdd"
                      optionLabel="label"
                      optionValue="value"
                      [filter]="true"
                      filterPlaceholder="Logik suchen..."
                      placeholder="Logik-Block hinzufügen..."
                      [loading]="loadingLogics"
                      class="w-full">
            </p-select>
        </div>
        <p-button icon="fa-regular fa-plus"
                  label="Hinzufügen"
                  [disabled]="!selectedLogicToAdd"
                  (onClick)="addLogic()"
                  severity="secondary">
        </p-button>
    </div>

    <!-- Selected Logic List -->
    @if (selectedLogics.length === 0) {
        <div class="flex align-items-center justify-content-center p-4 surface-ground border-round">
            <div class="text-center">
                <i class="fa-regular fa-inbox text-4xl text-400 mb-2"></i>
                <p class="text-500 mt-2 mb-0">Noch keine Logik-Blöcke ausgewählt</p>
            </div>
        </div>
    } @else {
        <div class="flex flex-column gap-2">
            @for (logic of selectedLogics; track logic.logicId; let i = $index) {
                <div class="flex align-items-center gap-3 p-3 surface-ground border-round lg-poc-logic-item">
                    <div class="flex align-items-center justify-content-center border-circle bg-primary text-primary-contrast w-2rem h-2rem text-sm font-bold lg-poc-order-badge">
                        {{ logic.orderPriority }}
                    </div>
                    <span class="flex-grow-1 font-medium">{{ logic.logicName }}</span>
                    <div class="flex gap-1">
                        <p-button icon="fa-regular fa-arrow-up"
                                  [rounded]="true"
                                  [text]="true"
                                  severity="secondary"
                                  size="small"
                                  [disabled]="i === 0"
                                  (onClick)="moveUp(i)">
                        </p-button>
                        <p-button icon="fa-regular fa-arrow-down"
                                  [rounded]="true"
                                  [text]="true"
                                  severity="secondary"
                                  size="small"
                                  [disabled]="i === selectedLogics.length - 1"
                                  (onClick)="moveDown(i)">
                        </p-button>
                        <p-button icon="fa-regular fa-times"
                                  [rounded]="true"
                                  [text]="true"
                                  severity="danger"
                                  size="small"
                                  (onClick)="removeLogic(i)">
                        </p-button>
                    </div>
                </div>
            }
        </div>
    }

    <!-- Error message -->
    @if (error) {
        <p-message severity="error" [text]="error"></p-message>
    }

    <!-- Footer -->
    <div class="flex justify-content-between pt-3 border-top-1 surface-border">
        <p-button label="Zurück"
                  icon="fa-regular fa-arrow-left"
                  severity="secondary"
                  [disabled]="creating"
                  (onClick)="onBack()">
        </p-button>
        <p-button label="Erstellen"
                  icon="fa-regular fa-wand-magic-sparkles"
                  [loading]="creating"
                  [disabled]="!isValid || creating"
                  (onClick)="onCreate()">
        </p-button>
    </div>

</div>
